import { cashAnswerCiteLine, versionsDiffer } from './cashAnswerCite.ts'
import { sourceHref } from '../cashReport/sourceLink.ts'
import { sourceChipLabel } from '../cashReport/sourceChipLabel.ts'
import type { ForecastLine } from '../../api/cashReport'

type Props = {
  versionId?: string | null
  computedAt?: string | null
  pageVersionId?: string | null
  confidence?: string | null
  sourceLines?: ForecastLine[]
  onOpenReport: () => void
  onRefresh?: () => void
  onOpenSource?: (href: string) => void
}

export default function SorenCashCite({
  versionId,
  computedAt,
  pageVersionId,
  confidence,
  sourceLines = [],
  onOpenReport,
  onRefresh,
  onOpenSource,
}: Props) {
  const stale = versionsDiffer(versionId, pageVersionId)
  return (
    <div className="soren-cash-cite" data-testid="soren-cash-cite">
      <p className="soren-cash-cite-line" data-testid="soren-version-line">
        {cashAnswerCiteLine({ versionId, computedAt })}
        {confidence ? ` · ${confidence}` : ''}
      </p>
      {stale ? (
        <p className="soren-cash-stale" data-testid="soren-report-updated">
          Report updated since this answer.{' '}
          <button type="button" className="cr-btn" onClick={onRefresh}>Refresh</button>
        </p>
      ) : null}
      <div className="soren-cash-sources">
        {sourceLines.slice(0, 6).map((line) => {
          const label = sourceChipLabel(line)
          if (!label) return null
          const href = sourceHref({ ...line, focus: line.focus })
          if (!href) return null
          const sorenHref = href.replace('sourceContext=cash-report', 'sourceContext=soren')
          return (
            <button
              key={`${line.source_type}:${line.source_id}`}
              type="button"
              className="suggestion"
              data-testid="soren-source-link"
              onClick={() => onOpenSource?.(sorenHref)}
            >
              {label}
            </button>
          )
        })}
      </div>
      <button
        type="button"
        className="cr-btn dark"
        data-testid="soren-open-cash-report"
        onClick={onOpenReport}
      >
        Open Company Cash Report
      </button>
    </div>
  )
}
